import React, { FC } from 'react';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import { useApiFrontendServiceLandingLocaleFaqsList } from '@rover/rsdk/src/apiClient/latest/api-frontend-service-landing-locale-faqs-list';
import type { ServiceLandingPathDescriptor } from '@rover/shared/js/hooks/useServiceLanding';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

type ServiceLandingFaqListProps = {
  descriptor: ServiceLandingPathDescriptor;
  title: React.ReactNode;
};

const ServiceLandingFaqList: FC<ServiceLandingFaqListProps> = ({ descriptor, title }) => {
  const { countryUrlPrefix, language, serviceLandingSlug } = descriptor;
  const { data: faqs } = useApiFrontendServiceLandingLocaleFaqsList(
    countryUrlPrefix,
    language,
    serviceLandingSlug
  );

  if (!faqs || faqs.length === 0) return null;
  const brandDisplayName = getBrandDisplayName();

  return (
    <LandingFaqList faqs={faqs} mt="16x" mb="8x">
      <FaqSection.Header variant="heading" webProps={{ responsive: false }}>
        {title}
      </FaqSection.Header>
      <FaqSection.Subheader>
        Frequently asked questions about {brandDisplayName}
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default ServiceLandingFaqList;
